<template>
  <VuePerfectScrollbar class="bb-contact-companies-sidebar" v-click-outside="closeSidebar">
    <div class="bb-contact-companies-sidebar-header">
      <div>
        {{ headerName }}
      </div>
      <i class="icon-cross bb-contact-companies-sidebar-header__close" @click="closeSidebar"/>
    </div>
    <ContactCompanySidebarClients
      v-if="isPartnerCard"
      :contactId="contactId"
    />
    <template v-else>
    <div class="bb-contact-companies-sidebar-add">
      <div class="bb-contact-companies-sidebar__title">
        You can add a company yourself
      </div>
      <button class="bb-button-dashed bb-contact-companies-sidebar-add__button" @click="goToCompanyCard('new')">
        Add a company
      </button>
    </div>
    <div v-if="clientCompanies.length > 0">
      <div class="bb-contact-companies-sidebar__title">
        Choose from existing
      </div>
      <div class="bb-contact-companies-sidebar-list">
        <div class="bb-contact-companies-sidebar-list__company"
             :class="{'bb-contact-companies-sidebar-list__company_active': activeCompanyId === company.id}"
             @click="goToCompanyCard(company.id)"
             v-for="company in clientCompanies"
             :key="company.id">
          {{company.name}}
        </div>
      </div>
    </div>
    </template>
  </VuePerfectScrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ContactCompanyApi from '@/api/ContactCompanies/api'
import ContactCompanySidebarClients
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanySidebar/ContactCompanySidebarClients'

export default {
  name: 'ContactCompanySidebar',
  components: {
    ContactCompanySidebarClients,
    VuePerfectScrollbar
  },
  props: {
    isPartnerCard: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerName () {
      return this.isPartnerCard ? 'Referred clients' : 'Company management'
    },
    clientCompanies: {
      get () {
        return this.$store.getters.clientCompanies
      },
      set (data) {
        this.$store.dispatch('setClientCompanies', data)
      }
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    activeCompanyId () {
      return this.$route.params.company
    },
    contactId () {
      return this.$route.params.id
    }
  },
  methods: {
    goToCompanyCard (id) {
      this.$emit('openCompany')
      if (this.$route.params.company === id) return
      this.$router.push({name: 'CompanyContact', params: {company: id}})
    },
    getCompanies ({limit = 50, page = 1, status, sort}) {
      ContactCompanyApi.getContactCompanies({limit, page, status, client: this.contactId, sort})
        .then((resp) => {
          this.clientCompanies = resp.data.clientcompanies
        })
        .catch((e) => {
          console.error(e)
        })
    },
    closeSidebar () {
      this.$emit('close')
    }
  },
  beforeMount () {
    if (!this.isPartnerCard) this.getCompanies({})
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-contact-companies-sidebar {
    width: 365px;
    height: calc(100vh - 60px);
    box-shadow: -7px 0 18px rgba($color-black, 0.08);
    border-radius: 6px;
    background: $color-white;
    overflow: hidden;

    &-header {
      position: sticky;
      top: 0;
      border-bottom: 1px solid $color-wild-sand;
      background: $color-white;
      padding: 12px 25px;
      font-weight: 600;
      font-size: 15px;
      line-height: 18px;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &__close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        color: $color-accent;
        background: rgba($color-accent, 0.11);
        border-radius: 50%;
        cursor: pointer;
        font-size: 16px;

        &:hover {
          color: $color-accent-hover;
          background: rgba($color-accent-hover, 0.11);
        }
      }
    }

    &__title {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
    }

    &-add {
      padding: 20px 25px 70px;
      text-align: center;

      &__button {
        font-weight: 600;
        font-size: 11px;
        margin-top: 12px;
      }
    }

    &-list {
      display: grid;
      grid-gap: 8px;
      font-weight: 600;
      font-size: 11px;
      line-height: 13px;
      text-align: center;
      margin-top: 12px;
      padding: 0 25px;

      &__company {
        position: relative;
        border: 1px solid $color-mercury;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 12px;
        color: $color-accent;
        background-color: $color-white;
        cursor: pointer;
        overflow: hidden;
        transition: 0.3s;

        &_active {
          pointer-events: none;
        }

        &_active,
        &:hover {
          color: $color-white;
          background-color: $color-accent;
          border-color: transparent;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanySidebar/ContactCompanySidebar.vue